import {Button, IconButton, useTranslationContext} from 'platform/components';

import {SECTION_BORDER_BOTTOM} from '../../constants/borderStyles';
import {SELECTION_TEST_ID_PREFIX} from '../../constants/selectionColumn';
import {ActionDefinitionObject} from '../../types/ActionDefinition';

interface BulkActionsBarProps {
  selectedCount: number;
  bulkActions: ActionDefinitionObject;
  onDeselectAll: () => void;
  onBulkAction: (actionKey: string) => void;
  disableAllActions?: boolean;
  isLoading?: boolean;
}

/**
 * Shows: selected count text | bulk action buttons | deselect IconButton.
 *
 * When no bulk actions are available, degrades gracefully to count + deselect only.
 */
export function BulkActionsBar(props: BulkActionsBarProps) {
  const t = useTranslationContext();

  const actionEntries = Object.entries(props.bulkActions);

  return (
    <div
      className="flex items-center justify-between px-2 py-2 bg-gray-50 text-sm text-gray-600 flex-shrink-0"
      style={SECTION_BORDER_BOTTOM}
    >
      <span>
        {t('page.datagrid.labels.numberOfSelectedRows', {
          selectedRows: String(props.selectedCount),
        })}
      </span>

      <div className="flex items-center gap-1">
        {actionEntries.map(([actionKey, actionDef]) => (
          <Button
            key={actionKey}
            variant="secondary"
            size="small"
            title={actionDef.title}
            leftIcon={actionDef.icon.value}
            onClick={() => props.onBulkAction(actionKey)}
            isDisabled={props.disableAllActions || props.isLoading}
            isLoading={props.isLoading}
            data-testid={`${SELECTION_TEST_ID_PREFIX}-bulk-${actionKey}`}
          />
        ))}
        <IconButton
          icon="navigation/close"
          size="small"
          priority="secondary"
          onClick={props.onDeselectAll}
          data-testid={`${SELECTION_TEST_ID_PREFIX}-deselect-all`}
        />
      </div>
    </div>
  );
}
